import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { VATs } from '../../../customer-billing-components/VAT';
import { CustomerBillingCustomerModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer.model';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-customer-billing-customer-unit-edit-payment-information',
    templateUrl: './customer-billing-customer-unit-edit-payment-information.component.html',
    styleUrls: ['./customer-billing-customer-unit-edit-payment-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-unit-edit-payment-information' },
    providers: [
        { provide: FiComponentsContainer, useExisting: CustomerBillingCustomerUnitEditPaymentInformationComponent },
    ],
    standalone: false,
})
export class CustomerBillingCustomerUnitEditPaymentInformationComponent extends FiComponentsContainer {
    @Input() customer: CustomerBillingCustomerModel;
    @Input() resellerName: string;
    VATs = VATs;
}
